var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "robot-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.dialogForm.show,
            title: "新建计划",
            width: "580px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialogForm, "show", $event)
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "show-message": false,
                    "inline-message": false
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "计划名称", prop: "planName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入计划名称",
                          maxlength: "50",
                          disabled: !_vm.dialogForm.editor,
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.planName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "planName", $$v)
                          },
                          expression: "form.planName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr-top",
                      attrs: { label: "机器人名称", prop: "robotName" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请选择需要的机器人名称",
                            disabled: !_vm.dialogForm.editor
                          },
                          model: {
                            value: _vm.form.robotName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "robotName", $$v)
                            },
                            expression: "form.robotName"
                          }
                        },
                        _vm._l(_vm.robotList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.taskName, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr-top",
                      attrs: { label: "计划频次", prop: "frequency" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: !_vm.dialogForm.editor },
                          model: {
                            value: _vm.form.frequency,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "frequency", $$v)
                            },
                            expression: "form.frequency"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("单次")
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("每天")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.frequency === 0,
                          expression: "form.frequency === 0"
                        }
                      ],
                      staticClass: "mr-top",
                      attrs: { label: "选择日期", prop: "selectDate" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          disabled: !_vm.dialogForm.editor,
                          type: "date",
                          placeholder: "选择日期"
                        },
                        model: {
                          value: _vm.form.selectDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "selectDate", $$v)
                          },
                          expression: "form.selectDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.frequency === 1,
                          expression: "form.frequency === 1"
                        }
                      ],
                      staticClass: "mr-top",
                      attrs: { label: "选择日期", prop: "selectDateArr" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          disabled: !_vm.dialogForm.editor,
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期"
                        },
                        model: {
                          value: _vm.form.selectDateArr,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "selectDateArr", $$v)
                          },
                          expression: "form.selectDateArr"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr-top",
                      attrs: { label: "运行时间", prop: "elapsedTime" }
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          disabled: !_vm.dialogForm.editor,
                          "value-format": "HH:mm",
                          format: "HH:mm",
                          "range-separator": ":",
                          placeholder: "请选择当日运行时间"
                        },
                        model: {
                          value: _vm.form.elapsedTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "elapsedTime", $$v)
                          },
                          expression: "form.elapsedTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("span", { staticClass: "prompt mr-top" }, [
                _vm._v("温馨提示：机器人将会根据选择时间运行")
              ])
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.nextStep } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }